export class EnumHelper {
	static normalizeHotchocolateEnum(item: any): string {
		const itemTxt = (item + "").toLowerCase();
		
		let result = "";
		const length = itemTxt.length;
		for (let i = 0; i < length; i++) {
			const element = itemTxt[i];
			if (i === 0) {
				result += element.toUpperCase();
				continue;
			}
			
			if (element === "_" && i + 1 < length - 1) {
				result += itemTxt[i + 1].toUpperCase();
				i++;
				continue;
			}
			result += element;
		}
		
		return result;
	}
}
